import { Component, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { GISOrderHistoryItemArray } from '../../../app/models/domain/gis.order.history.item';
import { Router } from '../../../../node_modules/@angular/router';
import { SortBot } from '../../../app/helpers/sort';

export interface IGISOrderHistoryDialogModel {
    GISHistory: GISOrderHistoryItemArray
}

@Component({
    selector: 'gis-order-history-dialog',
    templateUrl: './gis.order.history.dialog.html',
    styleUrls: ['./gis.order.history.dialog.scss']
})

export class GISOrderHistoryDialog extends DialogComponent<IGISOrderHistoryDialogModel, boolean> implements IGISOrderHistoryDialogModel, AfterViewInit, OnInit, OnDestroy {

    IsBusy: Boolean = true;

    GISHistory: GISOrderHistoryItemArray;

    gisHistoryResultRows: number = 25;
    gisHistoryFirstResult: number = 0;
    gisHistoryLastResult: number = 24;

    ngAfterViewInit(): void {
        // throw new Error("Method not implemented.");
    }

    constructor(dialogService: DialogService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {

        // this.MemberID = this.ticketManager.Ticket().MemberID;
        this.IsBusy = false;

    }

    ngOnDestroy() {

    }

    SortBy(sortVar1: string, sortVar2: string = '') {
        this.GISHistory = SortBot.SortAuto(this.GISHistory, sortVar1, sortVar2);
    }

    confirm() {
        this.closeOK();
    }

    onMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    closeOK() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
    }

    paginateGISHistory(e) {
        this.gisHistoryFirstResult = e.page * e.rows;
        this.gisHistoryLastResult = this.gisHistoryFirstResult + e.rows;
    }

}
